import api from './axiosConfig';

const BASE = '/trucking/drivers';

const driverAPI = {
  getAll:  (params = {}) => api.get(BASE, { params }),
  getById: (id)          => api.get(`${BASE}/${id}`),
  create:  (data)        => api.post(BASE, data),
  update:  (id, data)    => api.put(`${BASE}/${id}`, data),
  delete:  (id)          => api.delete(`${BASE}/${id}`),
  search:  (term, limit = 10) =>
    api.get(`${BASE}/search`, { params: { search: term, limit } }),
  getPayoutSummary: (id, from, to) =>
    api.get(`${BASE}/${id}/payout-summary`, { params: { from, to } }),
};

export default driverAPI;
